module.exports = __webpack_public_path__ + "static/media/builder-landing-help-2.dbaacb6e.svg";